module.exports = __webpack_public_path__ + "img/no-file-select.4c11f030.svg";